import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../shareModule/services/customer.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { User } from 'src/app/shareModule/models/user.model';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details/user-details.selector';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';

@Component({
    selector: 'app-manual-review-task',
    templateUrl: './manual-review-task.component.html',
    styleUrls: ['./manual-review-task.component.scss']
})
export class ManualReviewTaskComponent implements OnInit, OnDestroy {
    tasks: Array<{ id: number; name: string; imageUrl: string }> = [];
    pinnedTasks: any[] = [];
    @ViewChild('applyTaskModal', { static: false }) applyTaskModal?: TemplateRef<any>;
    @ViewChild('taskDetailModal', { static: false }) taskDetailModal?: TemplateRef<any>;
    modalRef?: NgbModalRef | null;
    selectedTask: any | null = null;
    uploadedFile: File | null = null;
    remark = '';
    previewUrl: string | ArrayBuffer | null = null;
    isLoading = false;
    isSubmitting = false;
    imageUrl = environment.ImageUrl;

    // Pagination properties
    currentPage = 1;
    pageSize = 10;
    tasksPagination: any = {
        currentPage: 1,
        hasNextPage: false,
        hasPreviousPage: false,
        limit: 10,
        totalPages: 1,
        totalRecords: 0
    };

    pages: number[] = [];

    @Input() subRegionName: string;
    @Input() userRegionId: number;
    @Input() hideFilter: boolean = false;
    @Input() title: string = 'Available Tasks';

    specialCategories = [
        'Survey',
        'Taste Test',
        'Micro Job',
    ]

    specialTags = {
        'taste_test': 'Taste Test',
        'micro_job': 'Micro Job',
        'survey': 'Survey',
    }

    selectedTab = '';

    referralCode = null;

    // Search properties
    searchTerm = '';
    private searchSubject = new Subject<string>();

    // Make Math available in template
    Math = Math;

    // Icon map for special categories
    private categoryToIconClass: Record<string, string> = {
        'Survey': 'fa-clipboard-check',
        'Taste Test': 'fa-utensils',
        'Micro Job': 'fa-briefcase'
    };

    getCategoryIcon(category: string): string {
        return `fas ${this.categoryToIconClass[category] || 'fa-tag'}`;
    }

    constructor(
        private modalService: NgbModal,
        private customerService: CustomerService,
        private toastr: ToastrService,
        private local: LocalServiceService,
        private commonService: CommonService,
        private cdr: ChangeDetectorRef,
        private route: ActivatedRoute,
        private sharedService: SharedService,
        private store: Store<AppState>,
        private roleService: RoleService
    ) {
        this.route.params.subscribe((params) => {
            if (params['user']) {
                this.referralCode = params['user'];
            }
        });
    }

    regions = [];
    subRegions = [];
    regionId = '';
    subRegionId = '';
    user: any;
    isAdmin: boolean = false;
    ngOnInit(): void {
        if (this.sharedService.isBrowser()) {
            this.setupSearchDebounce();
            this.loadAvailableTasks();
            this.loadPinnedTasks();

            this.commonService.regionObserver.subscribe((resp: any) => {
                this.regions = resp;
            });

            this.commonService.subRegionObserver.subscribe((resp: any) => {
                this.subRegions = resp;
            });


            this.store.pipe(select(selectUser)).subscribe((user: User) => {
                this.user = user;
                this.roleService.rolesSubject.subscribe((response) => {
                    this.isAdmin = response?.userType?.includes('ADMIN');
                    this.cdr.detectChanges();
                });
                this.cdr.detectChanges();
            });
        }
    }

    ngOnDestroy(): void {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    }

    private setupSearchDebounce(): void {
        this.searchSubject
            .pipe(
                debounceTime(300),
                distinctUntilChanged()
            )
            .subscribe(searchTerm => {
                this.currentPage = 1;
                this.loadAvailableTasks();
            });
    }
    loadAvailableTasks(page: number = this.currentPage): void {
        this.isLoading = true;
        this.currentPage = page;

        this.customerService.getAvailableTasks({
            page,
            limit: this.pageSize,
            search: this.searchTerm.trim(),
            referralCode: this.referralCode,
            userRegionId: this.userRegionId,
            subRegionId: this.subRegionId,
            category: this.selectedTab,
            tags: this.selectedTab
        }).subscribe({
            next: (response) => {
                this.tasks = response.body.data;
                this.tasks = this.tasks.map((task: any) => {
                    if (task.memberShopProduct) {
                        task.image = this.imageUrl + task.memberShopProduct.primaryImage;
                    } else {
                        task.image = 'assets/images/general-task-list.png';
                    }
                    return task;
                });
                this.tasksPagination = response.body.pagination;
                this.isLoading = false;
                this.cdr.detectChanges();
                this.startCountdownInterval();
            },
            error: (error) => {
                console.error('Error loading tasks:', error);
                this.isLoading = false;
                this.toastr.error('Failed to load tasks. Please try again.');
                this.cdr.detectChanges();
            }
        });
    }

    private countdownInterval: any;

    startCountdownInterval(): void {
        if (!this.sharedService.isBrowser()) return;
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }

        this.countdownInterval = setInterval(() => {
            this.tasks.map((task: any) => {
                task.countdown_limit = this.calculateCountdownLimit(task.limit_after_accept, task.accepted_at);
            });
            this.cdr.detectChanges();
        }, 1000);
    }

    calculateCountdownLimit(limit: any, acceptedAt: string = "1758199557"): string {
        if (acceptedAt == undefined) return "00:00:00";
        // console.log(acceptedAt, limit, "Created At and Limit");

        // Convert acceptedAt to milliseconds since it's a Unix timestamp
        const createdTime = Number(acceptedAt) * 1000;

        const now = Date.now();
        // Use the limit parameter to calculate hours from acceptedAt
        const limitDate = createdTime + (parseInt(limit) * 60 * 60 * 1000);
        const timeRemaining = limitDate - now;

        // console.log(timeRemaining, "Time Remaining");

        // Check if timeRemaining is always less than 0
        if (timeRemaining <= 0) {
            // console.warn("Warning: timeRemaining is less than or equal to 0, indicating the countdown has expired.");
            return "00:00:00";
        }

        const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
        const result = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        // console.log(result, "Result");
        return result;
    }

    onPageChange(page: number): void {
        if (page >= 1 && page <= this.tasksPagination.totalPages && page !== this.currentPage) {
            this.loadAvailableTasks(page);
        }
    }

    onPageSizeChange(): void {
        this.currentPage = 1;
        this.loadAvailableTasks();
    }

    onSearchChange(): void {
        this.searchSubject.next(this.searchTerm);
    }

    clearSearch(): void {
        this.searchTerm = '';
        this.searchSubject.next('');
    }

    applyTask(task: any): void {
        if (!this.user?.id) {
            this.toastr.error('Please login to apply task');
            document.getElementById('loginBtn')?.click();
            return;
        }

        if (task.level_required && this.user?.level < parseInt(task.level_required)) {
            this.toastr.error('You are not eligible to apply this task');
            return;
        }

        this.selectedTask = task;
        this.local.alertLoading({ message: 'Applying task...' })
        this.customerService.applyTask(task.id).subscribe({
            next: (response) => {
                this.loadAvailableTasks();
                this.toastr.success('Application submitted successfully!');
                this.local.alertClose();
            },
            error: (error) => {
                this.toastr.error(error.error.message || 'Failed to submit application. Please try again.');
                this.local.alertClose();
            }
        });
    }

    openApplyModal(task: { id: number; name: string; imageUrl: string }): void {
        this.selectedTask = task;
        this.uploadedFile = null;
        this.previewUrl = null;
        if (this.applyTaskModal) {
            this.modalRef = this.modalService.open(this.applyTaskModal, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'manual-review-modal'
            });
        }
    }

    openPinnedDetail(task: any): void {
        this.selectedTask = task;
        if (this.taskDetailModal) {
            this.modalRef = this.modalService.open(this.taskDetailModal, {
                size: 'md',
                centered: true,
                windowClass: 'manual-review-modal'
            });
        }
    }

    closeModal(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
        } else {
            this.modalService.dismissAll();
        }
        this.selectedTask = null;
        this.uploadedFile = null;
        this.previewUrl = null;
    }

    // Close only the current (apply) modal without clearing selectedTask,
    // so the detail modal data remains intact if it's underneath
    closeApplyOnly(): void {
        if (this.modalRef) {
            this.modalRef.close();
            this.modalRef = null;
        }
        // Keep selectedTask as-is to preserve detail modal data
        this.uploadedFile = null;
        this.previewUrl = null;
    }

    onFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) {
            this.uploadedFile = null;
            this.previewUrl = null;
            return;
        }
        const file = input.files[0];
        this.uploadedFile = file;
        const reader = new FileReader();
        reader.onload = () => {
            this.previewUrl = reader.result;
        };
        reader.readAsDataURL(file);
    }

    submitApplication(): void {
        if (!this.selectedTask || !this.uploadedFile) {
            this.toastr.error('Please select an image and remark');
            return;
        }

        if (this.selectedTask.level_required && this.user?.level < parseInt(this.selectedTask.level_required)) {
            this.toastr.error('You are not eligible to apply this task');
            return;
        }

        this.isSubmitting = true;
        const formData = new FormData();
        formData.append('image', this.uploadedFile);
        formData.append('remark', this.remark || '');
        formData.append('taskId', this.selectedTask.id.toString());

        this.customerService.submitTask(formData).subscribe({
            next: (response) => {
                this.isSubmitting = false;
                this.toastr.success('Application submitted successfully!');
                this.modalService.dismissAll();
                this.modalRef = null;
                // Optionally reload tasks
                this.loadAvailableTasks();
            },
            error: (error) => {
                this.isSubmitting = false;
                console.error('Error submitting application:', error);
                this.toastr.error(error.error.message || 'Failed to submit application. Please try again.');
            }
        });
    }

    loadProducts(category: string | null): void {
        this.selectedTab = category || '';
        this.loadAvailableTasks();
    }

    pinTask(task: any): void {
        this.customerService.pinTask(task.id).subscribe({
            next: (response) => {
                this.toastr.success('Task pinned successfully!');
                task.isPinned = !task.isPinned;
                this.cdr.detectChanges();
                this.loadPinnedTasks();
            },
            error: (error) => {
                this.toastr.error('Failed to pin task. Please try again.');
            }
        });
    }

    loadPinnedTasks(): void {
        this.customerService.getPinnedTasks().subscribe({
            next: (response) => {
                this.pinnedTasks = response.body;
                this.pinnedTasks = this.pinnedTasks.map((task: any) => {
                    if (task.memberShopProduct) {
                        task.image = this.imageUrl + task.memberShopProduct.primaryImage;
                    } else {
                        task.image = 'assets/images/general-task-list.png';
                    }
                    return task;
                });
                this.cdr.detectChanges();
            }
        });
    }

    // Filter subregions based on selected region
    get filteredSubRegions(): any[] {
        if (!this.regionId) {
            return [];
        }

        const region = this.regions.find((i: any) => i.regionId === parseInt(this.regionId));
        if (!region) {
            return [];
        }
        return this.subRegions.filter(subRegion => subRegion.regionName === region.name);
    }

    deleteTask(task: any): void {
        this.local.alertConfirm({
            message: 'Are you sure you want to delete this task?'
        }).then((resp) => {
            if (resp.isConfirmed) {
                this.customerService.deleteTask(task.id).subscribe({
                    next: (response) => {
                        this.toastr.success('Task deleted successfully!');
                        this.loadAvailableTasks();
                    }
                })
            }
        })
    }

    viewProduct(task: any) {
        if (!task?.memberShopProduct) {
            return;
        }
        console.log(task, "TASK");
        this.sharedService.triggerOpenProductDetail({
            id: task.memberShopProduct.id,
            enableMemberShop: true
        })
    }

    handlePauseTask(task: any): void {
        this.customerService.pauseTask(task.id).subscribe({
            next: (response) => {
                this.toastr.success('Task paused successfully!');
                task.is_paused = !task.is_paused;
                this.cdr.detectChanges();
            },
            error: (error) => {
                this.toastr.error('Failed to pause task. Please try again.');
            }
        });
    }
}
